import { HttpContextToken } from '@angular/common/http';

/**
 * Set on a request's HttpContext to force the school-user (or impersonation)
 * token even while the current page is still `/admin/*` — needed by
 * `AuthSessionService.fetchAndStoreRoles()`, which is always about "the
 * current school user," never the admin. Without this, the roles fetch that
 * immediately follows `adminAuthControllerImpersonate()` would still read
 * `router.url` as `/admin/...` (navigation to `/principal/*` hasn't happened
 * yet) and wrongly authenticate as the admin, fetching the wrong — usually
 * empty — role list for the impersonated user. Checked by `authInterceptor`.
 *
 * Lives in its own file (rather than on the interceptor) so `AuthSessionService`
 * can import it without a circular dependency between the two.
 */
export const FORCE_USER_TOKEN = new HttpContextToken<boolean>(() => false);
